module.exports = __webpack_public_path__ + "img/editLatexWhite.a212f915.svg";